import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'Spreadsheet', href: '/#what-is' },
    { name: 'How It Works', href: '/#how-it-works' },
    { name: 'Safety', href: '/#safety' },
    { name: 'Articles', href: '/#articles' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap cursor-pointer"
          >
            Kakobuy<span className="text-primary-500">Finds</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Kakobuy Sheet
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 py-2.5 px-3 rounded-lg cursor-pointer"
              >
                {link.name}
              </Link>
            ))}

            <div className="my-2 border-t border-background-200/70"></div>

            <button
              onClick={() => setCategoriesOpen(!categoriesOpen)}
              className="flex items-center justify-between text-sm font-semibold text-foreground-900 py-2.5 px-3 rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer w-full text-left"
            >
              <span>Categories</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`text-base transition-transform duration-200 ${categoriesOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
              </span>
            </button>

            {categoriesOpen && (
              <div className="grid grid-cols-2 gap-2 pb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-2 text-xs text-foreground-600 hover:text-primary-500 hover:bg-background-100 py-2 px-3 rounded-lg cursor-pointer transition-colors duration-200"
                  >
                    <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className={`${cat.icon} text-xs`}></i>
                    </span>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <div className="my-2 border-t border-background-200/70"></div>

            <Link
              to="/kakobuy-spreadsheet-guide"
              onClick={() => setMobileOpen(false)}
              className="text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 py-2.5 px-3 rounded-lg cursor-pointer"
            >
              Complete Guide
            </Link>
            <Link
              to="/kakobuy-vs-cssbuy-spreadsheet"
              onClick={() => setMobileOpen(false)}
              className="text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 py-2.5 px-3 rounded-lg cursor-pointer"
            >
              Kakobuy vs CSSBuy
            </Link>
            <Link
              to="/category-guide-shoes"
              onClick={() => setMobileOpen(false)}
              className="text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 py-2.5 px-3 rounded-lg cursor-pointer"
            >
              Shoes Category Guide
            </Link>
            <Link
              to="/complete-safety-guide"
              onClick={() => setMobileOpen(false)}
              className="text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 transition-colors duration-200 py-2.5 px-3 rounded-lg cursor-pointer"
            >
              Complete Safety Guide
            </Link>

            <div className="mt-3 pt-3 border-t border-background-200/70">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="block w-full px-5 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold text-center hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                Kakobuy Sheet
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}